import { Tile } from '@components/shared/tile.component';
import { cn } from '@lib/utils';
import { useGetChallenges } from '@queries/challenges.query';
import { type FunctionComponent, useState } from 'react';
import { ChallengeCard } from './challenge-card.component';
import { ChallengeModal } from './challenge-modal.component';

type TechChallengesGridProps = {
  className?: string;
};

export const TechChallengesGrid: FunctionComponent<TechChallengesGridProps> = (props) => {
  const { className } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: challenges, isPending } = useGetChallenges();

  const hasChallenges = Boolean(challenges && challenges.length > 0);

  const openModal = (): void => {
    setIsModalOpen(true);
  };

  const closeModal = (): void => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Tile
        className={cn('w-full', (!hasChallenges || isPending) && 'min-h-[260px]', className)}
        emptyState={{
          message: 'Add Tech Challenge',
          onClick: openModal,
          title: 'No Tech Challenges',
        }}
        header={{
          button: {
            onClick: openModal,
            text: '+ Add Challenge',
          },
          title: 'Tech Challenges',
        }}
        isEmpty={!hasChallenges}
        isLoading={isPending}
      >
        <div className="flex flex-col gap-2 bg-gray-100 p-2 rounded-lg">
          {challenges?.map((challenge) => (
            <ChallengeCard
              key={challenge.id}
              challenge={challenge}
            />
          ))}
        </div>
      </Tile>

      {isModalOpen && (
        <ChallengeModal
          challenge={undefined}
          isEdit={false}
          isOpen={isModalOpen}
          onClose={closeModal}
        />
      )}
    </>
  );
};
